import { categoryMapping } from 'views/SurvivalAnalysis/Helper/Function/helper.function';

export const healthScorePieRange = [
  { name: 'A', value: 30, color: categoryMapping.high.color },
  { name: 'B', value: 30, color: categoryMapping.med.color },
  { name: 'C', value: 40, color: categoryMapping.low.color },
];
